import React from 'react';
import styled from 'styled-components';

import Link from '#/components/basic/Link/Link';
import SimpleModal from '#/components/basic/modal/SimpleModal';
import coverImage from '#/components/rewards/images/katanaHero4x.png';
import UnlockWalletButton from '#/components/wallet/UnlockWalletButton';
import { KATANA_PERPS, urls } from '#/config/constants';
import { useSelector } from '#/reduxState/storeCore';

// import lamboVideoMp4 from './lamboVideo.mp4';
// import lamboVideoWebm from './lamboVideo.webm';

const MobileWrap = styled.div`
  height: 100%;
  max-width: 510px;
  margin: 0 auto;
  overflow: auto;
  background-color: var(--elevation-light);
`;

const Wrap = styled.div`
  display: grid;
  grid-template-columns: 245px 1fr 45px;

  .isMobileStyle & {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .isDesktopStyle & {
    height: 326px;
    overflow: hidden;
  }
`;

const ContentBlock = styled.div`
  .isDesktopStyle & {
    display: flex;
    align-items: center;
  }
  .isMobileStyle & {
    padding: 24px;
    height: 100%;
    flex: 1;
  }
`;

const ContentMain = styled.div`
  .isMobileStyle & {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

const Headline = styled.h1`
  margin: 0;
  padding: 4px 0 4px 0;
  color: #fff;
  font-size: var(--large);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  .isMobileStyle & {
    padding: 4px 0;
  }
`;

// const SubHeadline = styled.h2`
//   padding: 0 0 8px 0;
//   color: #9d98a4;
//   font-size: var(--medium);
//   font-style: normal;
//   font-weight: 700;
//   line-height: normal;
// `;

const Text = styled.div`
  color: #9d98a4;
  font-size: var(--medium);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-bottom: 16px;
`;

// const TextBlocked = styled(Text)`
//   /* Improve how current text wraps */
//   padding-right: 4px;
// `;

// const NoteBlocked = styled(Text)`
//   padding-top: 16px;
// `;

const TextLast = styled(Text)`
  padding-top: 16px;
  padding-bottom: 0;
`;

// const TextWhite = styled.div`
//   padding-top: 24px;
//   padding-bottom: 4px;
//   color: #eee;
//   font-size: var(--medium);
//   font-style: normal;
//   line-height: normal;
// `;

const MobileImgWrap = styled.div`
  flex-grow: 0;
  flex-basis: 50%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const DesktopImgWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 42px;
  background: var(--black);
  & > img {
    max-width: 100%;
  }
`;

export function SandboxTestnetWelcome() {
  const isMobile = useSelector(state => state.screen.isMobile);

  // const { notWhitelisted } = useWhitelistWithRedirect();

  // const videoBlock = (
  //   <VideoWrap>
  //     <video
  //       width={isMobile ? '100%' : '200'}
  //       height={isMobile ? undefined : '326'}
  //       autoPlay
  //       loop
  //       muted
  //       // Prevent iOS/Safari to go fullScreen
  //       playsInline
  //     >
  //       <source src={lamboVideoWebm} type="video/webm" />
  //       <source src={lamboVideoMp4} type="video/mp4" />
  //     </video>
  //   </VideoWrap>
  // );

  const inner = (
    <Wrap>
      {isMobile ? (
        <MobileImgWrap>
          <img
            src={coverImage}
            alt={KATANA_PERPS}
            width={isMobile ? '100%' : '200'}
            height={isMobile ? undefined : '326'}
          />
        </MobileImgWrap>
      ) : (
        <DesktopImgWrap>
          <img src={coverImage} alt={KATANA_PERPS} />
        </DesktopImgWrap>
      )}
      <ContentBlock>
        <ContentMain>
          <Headline>Welcome to {KATANA_PERPS} Sandbox</Headline>
          {/* <SubHeadline>Test. Compete. Earn.</SubHeadline> */}
          <div style={{ padding: 4 }} />
          <Text>
            Connect your wallet to automatically receive testnet funds and start
            trading.
            {/* Build and test trading strategies without risking funds. Join the
            IDEX Discord to whitelist a wallet and get started. */}
            {/* Connect your wallet now to gain access to the{' '}
            <strong>Trading Competition</strong>. Compete for your share of{' '}
            <b>{abbreviateNumber(TESTNET_BETA_REWARD_IDEX)} $IDEX</b> and
            exclusive prizes like our <b>Swag Pack</b>. */}
          </Text>
          <div>
            <UnlockWalletButton inline={!isMobile} widePadding />
          </div>
          {/* <TextWhite>Not whitelisted yet?</TextWhite> */}
          <TextLast>
            <Link href={urls.socialDiscord}>Join our discord!</Link>
          </TextLast>
        </ContentMain>
      </ContentBlock>
    </Wrap>
  );
  return isMobile ? (
    <MobileWrap>{inner}</MobileWrap>
  ) : (
    // Note: zIndex Must be Above Orderbook row and below Unlock Modal
    <SimpleModal padding="0" size="large" zIndex={1000}>
      {inner}
    </SimpleModal>
  );
}

// Not whitelisted code:
/**
 * Check URL for `notWhitelisted` string and remove it from path,
 * so user can refresh and retry again.
 */
// const useWhitelistWithRedirect = () => {
//   const [cachedNotWhitelisted, setCachedNotWhitelisted] = useState(false);
//   const { search } = useLocation();

//   const isNotWhitelistedPath = new URLSearchParams(search || '').get(
//     'isNotWhitelisted'
//   );

//   useEffect(() => {
//     if (cachedNotWhitelisted === true) {
//       // It's final state, user has to reload page
//       return;
//     }
//     if (isNotWhitelistedPath) {
//       setCachedNotWhitelisted(true);
//       // Remove search parameter,
//       // so once user reload page it would be gone
//       redirectTo(document.location.pathname);
//     }
//   }, [isNotWhitelistedPath, cachedNotWhitelisted]);

//   return { notWhitelisted: cachedNotWhitelisted || isNotWhitelistedPath };
// };
//
// const notWhitelisted = (
//   <Wrap>
//     {videoBlock}
//     <ContentBlock>
//       <ContentMain>
//         {/* TODO: remove screen? */}
//         <Headline>Sorry! You are not Whitelisted</Headline>
//         <SubHeadline>Join Discord & Earn Whitelist Access</SubHeadline>
//         <TextBlocked>
//           Get Whitelisted to gain access to the <b>Trading Competition</b> and
//           compete for your share of{' '}
//           <b>{abbreviateNumber(TESTNET_BETA_REWARD_IDEX)} $IDEX</b> as well as
//           exclusive prizes like our <b>Swag Pack</b>.
//         </TextBlocked>
//         <Button
//           inline
//           widePadding
//           onClick={() => {
//             window.open(urls.discordInvite, '_blank');
//           }}
//         >
//           Join Discord
//         </Button>
//         <NoteBlocked>
//           Note: If you participated in round 1 of the trading competition,
//           please revisit discord to whitelist a new wallet.
//         </NoteBlocked>
//       </ContentMain>
//     </ContentBlock>
//   </Wrap>
// )
